import { Component } from '@angular/core';

@Component({
  selector: 'clients-nside-io-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {}
